import { Grid, Table, TableBody, TableCell, TableHead, TableRow, Button } from '@mui/material';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { AppRootState, useAppDispatch } from '../../app/store';
import { UserItem } from './UserItem';
import { getUsersByAccountTC, UserType } from './users-reducer';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import { AccountType } from '../Accounts/accounts-reducer';
import { setCurrentLocation } from '../../app/cookies';
import { checkAutoLogin } from '../Login/auth-reducer';

export const UsersList = (props: UsersListPropsType) => {
  const dispatch = useAppDispatch()
  const isLoggedIn = useSelector<AppRootState, boolean>(state => state.auth.isLoggedIn)
  const users = useSelector<AppRootState, Array<UserType>>(state => state.users.users)
  const navigate = useNavigate()
  const account = props.account

  useEffect(() => {
    let token = checkAutoLogin(dispatch)
    if (token === null && isLoggedIn === false) {
      return navigate('/login')
    } else {
      if (token !== null && isLoggedIn === false) {
        return navigate(`/accountsList`)
      }
    }
   dispatch(getUsersByAccountTC({ accountId: props.account.id }))
  },[])

  return (
    <>
      <Table style={{ borderTop: '1px solid rgba(169, 169, 169, 1)', borderLeft: '1px solid rgba(169, 169, 169, 1)', borderRight: '0.6px solid rgba(169, 169, 169, 1)' }}>
        <TableHead style={{ backgroundColor: 'rgba(39,39,39,0.4)' }}>
          <TableRow>
            <TableCell style={{ textAlign: 'center'}}>
              #ID
            </TableCell>
            <TableCell >
              Name
            </TableCell>
            {/* <TableCell style={{ textAlign: 'center', minWidth: '75px' }}>
              LastName
              <span style={{ cursor: 'pointer', marginLeft: '5px' }}></span>
            </TableCell> */}
            {/* <TableCell style={{ textAlign: 'center', minWidth: '65px' }}>
              Description
              <span style={{ cursor: 'pointer', marginLeft: '5px' }}></span>
            </TableCell> */}
            <TableCell style={{ textAlign: 'center', minWidth: '154px' }}>
              Roles
            </TableCell>
            <TableCell style={{ textAlign: 'center', minWidth: '154px' }}>
              Projects
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {users.map((user) => (
            <UserItem key={user.id} user={user} />
          ))}
        </TableBody>
      </Table>
      <Grid container style={{ paddingBottom: '50px' }} spacing={3} alignItems="center">
        <Grid item xl={6} md={6} xs={6}>
        </Grid>
        <Grid item xl={6} md={6} xs={6} >
          <Button onClick={() => {
            setCurrentLocation(`\\ Accounts \\ ${props.account.name} \\ New User`)
            navigate(`/usersList/newUser`, { state:{ account} })
          }} className='addItemButton' style={{ float: 'right', marginTop: '40px' , color: '#00a0d1'}} startIcon={<PersonAddIcon style={{ color: 'grey' }} fontSize='medium' />}>
            Add new User
          </Button>
        </Grid>
      </Grid>
    </>
  )
}

export type UsersListPropsType = {
  account: AccountType
}
